<template>
  <div id="main" :class="weixin ? 'hiddden' : ''">
    <div class="detail">{{ title }}</div>
    <div v-html="info" class="con"></div>
    <div class="container con" style="margin-top: 20px;">
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
           <el-form-item prop="name" label="企业统一信用代码">
            <el-input v-model="ruleForm.name" placeholder="请输入企业统一信用代码"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="mob" label="手机号">
            <el-input v-model="ruleForm.mob" placeholder="请输入手机号"></el-input>
          </el-form-item> -->
          <!-- <el-form-item prop="code" label="验证码" class="code">
            <el-input v-model="ruleForm.code" placeholder="验证码"></el-input>
            <el-button type="button" @click="sendcode(123)" :disabled="disabled" v-if="disabled == false"
              class="btn">发送验证码</el-button>
            <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled == true" class="btn">{{
              btntxt }}</el-button>
          </el-form-item> -->
          
          <el-form-item prop="password" label="登录密码">
            <el-input type="password" v-model="ruleForm.password" autocomplete="new-password" placeholder="设置6至20位登录密码"></el-input>
          </el-form-item>
          <el-form-item prop="sure_pwd" label="确认密码">
            <el-input type="password" v-model="ruleForm.sure_pwd" placeholder="请再次输入登录密码"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button> -->
            <button class="next" @click.prevent="submitForm('ruleForm')">下一步</button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-if="weixin" class="we">
      <img src="../../assets/img/open.png" alt="">
    </div>
    <!-- 分享到朋友圈 -->
    <div class="pop1" v-if="this.$route.query.system">
      <div class="img-wrap">
        <img src="../../assets/img/arrow-left.png" class="img1" @click="goBack" />
        <!-- <div style="width: 50px;text-align:right;margin:20px 10px 0 0" @click="wxmini"> -->
        <div style="width: 50px;text-align:right;margin:20px 10px 0 0" @click="weChatShare">
          <img src="../../assets/img/share.png" style="width:40px;height:40px;" class="img2" />
        </div>
      </div>
      <div class="line-wrap">
        <img src="../../assets/img/line.png" class="img3" />
        <div>
          点击分享按钮，邀请企业完成注册，企业注册后即可在
          <span>“实习申请”</span>岗位列表选择企业进行申请
        </div>
      </div>
      <div class="no-share" @click="dialog1 = true">无法分享？点此处，复制邀请链接给企业</div>
      <div style="position: fixed; left: 0; right: 0; bottom: 0; height: 100px;" @click="wxmini1"></div>
    </div>
    <!-- 无法分享 -->
    <div class="dialog1" v-show="dialog1">
      <div class="invite-wrap">
        <div class="invite">
          <p>
            提示
            <span class="cancel1" style="float: right;" @click="dialog1 = false">x</span>
          </p>
          <!-- <p class="p1 none">请联系学校添加学生邀请函</p> -->
          <p class="p2" style="margin: 10px 0;">请复制以下链接，微信或短信发送给企业联系人，邀请企业完成注册，您即可在“我的岗位”列表查看提交申请</p>
          <textarea class="p3 copy" v-model="link"></textarea>
        </div>
        <div class="invite-btn">
          <button type="button" data-role="button" class="sure1" data-clipboard-target=".copy">复制链接</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validPhone ,validUscc} from '../../assets/js/validate';
import { tarsformHtml } from "@/assets/js/common.js";

import baseUrl from '../../api/baseUrl';
import vern from '../../client/version';
import axios from 'axios';
// import VConsole from 'vconsole';


let validPwd = function(rule, value, callback) {
  if (!value) {
    callback(new Error("请再次输入登录密码"));
  } else if (this.ruleForm.password !== value) {
    callback(new Error("请保证两次登录密码一致"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      title: '',
      info: '',
      ruleForm: {
        name:'',
        // mob: '',
        code: '',
        invite_school: this.$route.params.school_id,
        invite_code: this.$route.params.id,
        password: "",
        sure_pwd: "",
      },
      disabled: false,
      time: 0,
      btntxt: '重新发送',
      rules: {
        name: [{ required: true, trigger: "blur", validator: validUscc }],
        // mob: [{ required: true, trigger: 'blur', validator: validPhone }],
        password: [
          { required: true, message: "请输入登录密码" },
          { min: 6, max: 20, message: "设置6至20位登录密码" }
        ],
        sure_pwd: [
          {
            required: true,
            trigger: "blur",
            validator: validPwd.bind(this)
          }
        ]
        // code: [{ required: true, trigger: 'change', message: '请输入短信验证码' }],
      },
      dialog1: false,
      link: window.location.href.replace(/&system=[a-zA-Z]*/g, ''),
      weixin: false,
    };
  },
  mounted() {
    // new VConsole();
    this.getInviteInfo();
    if (this.isWeixin()) {
      this.weixin = true;
    }

    var clipboard = new this.clipboard('.sure1');

    clipboard.on('success', (e) => {
      this.$message.success('复制成功!');
      e.clearSelection();
    });

    clipboard.on('error', () => {
      this.$message.error('复制失败，请手动复制!');
    });
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
    weChatShare() {
      var obj = {
        title: this.title,
        desc: this.info.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ''),
        url: window.location.href.replace(/&system=[a-zA-Z]*/g, ''),
        imageurl: 'http://www.xixunyun.com/images/logo.png',
      };
      // console.log(obj);
      if (this.$route.query.system === 'ios') {
        // share(JSON.stringify(obj));
        window.webkit.messageHandlers.wxMiniShare.postMessage(JSON.stringify(obj));
      } else if (this.$route.query.system === 'android') {
        client.share(JSON.stringify(obj));
      }
    },
    async getDescribe() {
      let school_id = this.$route.params.school_id;
      let res = await this.$api.school.getDescribe(school_id);
      if (res.code === 0) {
        this.title = res.data.title;
        document.title = res.data.title;
        this.info = res.data.school_describe;
      }
    },
    async getInviteInfo() {
      let res = await this.$api.school.getInviteInfo(this.$route.params.id);
      if (res.code === 0) {
        this.title = res.data.title;
        document.title = res.data.title;
        this.info = tarsformHtml(res.data.school_describe);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.mobRegister();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //手机验证发送验证码
    sendcode(a) {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.ruleForm.mob == '') {
        this.$message({
          message: '手机号不能为空',
          center: true,
        });
        return;
      }
      if (!reg.test(this.ruleForm.mob)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true,
        });
        return;
      } else {
        axios
          .post(`${baseUrl}api/app/id_code/send`, {
            phone: this.ruleForm.mob,
            type: 'enterprise',
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                message: '发送成功',
                type: 'success',
                center: true,
              });
            } else if (res.data.code === 1) {
              this.$message({
                message: '系统检测到您输入的手机号已经与学号绑定，请联系企业相关负责人完成企业信息注册或者换个手机号重试！',
                duration: 0,
                showClose: true,
              });
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
          });

        // this.$api.common.sendCode({
        //   phone: this.ruleForm.mob,
        //   type: 'enterprise',
        // });
        // this.$message({
        //   message: "发送成功",
        //   type: "success",
        //   center: true
        // });
        this.time = 60;
        this.disabled = true;
        this.timer();
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + 's后重新获取';
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = '获取验证码';
        this.disabled = false;
      }
    },
    async mobRegister() {
      try {
        let params = {
          name:this.ruleForm.name,
          mob: this.ruleForm.name,
          code: this.randomCode(),
          password: this.ruleForm.password,
          invite_code: this.ruleForm.invite_code,
          school_id: this.ruleForm.invite_school,
        };
        let register_source = this.$route.query.register_source;
        if (register_source === 'student') {
          params.student_id = this.$route.query.invite_student_id;
        }
        if (register_source === 'yunnan' || register_source === 'vanber') {
          params.school_id = 92;
        }
        let res = await this.$api.account.register(params);
        if (res.code === 0) {
          this.$message({
            message: '注册成功，请补充相关信息',
            type: 'success',
            center: true,
          });
          let school_id = this.$route.params.school_id;
          let id = this.$route.params.id;

          if (this.$route.query.invite_student_id) {
            this.$router.push(`/share/${school_id}/${id}?register_source=${this.$route.query.register_source}&student_id=${this.$route.query.invite_student_id}`);
          } else {
            this.$router.push(`/share/${school_id}/${id}?register_source=${this.$route.query.register_source}`);
          }
        }
      } catch (e) {
        console.log('​catch -> e', e);
      }
    },
    randomCode() {
      const len = Math.floor(Math.random() * 3) + 4; // 4~6位
      const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*";
      let code = "";
      for (let i = 0; i < len; i++) {
        code += chars[Math.floor(Math.random() * chars.length)];
      }
      return code;
    },
    // async mobRegister() {
    //   try {
    //     let params = {
    //       mob: this.ruleForm.mob,
    //       code: this.ruleForm.code,
    //       invite_code: this.ruleForm.invite_code,
    //       school_id: this.ruleForm.invite_school,
    //     };
    //     let register_source = this.$route.query.register_source;
    //     if (register_source === 'student') {
    //       params.student_id = this.$route.query.invite_student_id;
    //     }
    //     if (register_source === 'yunnan' || register_source === 'vanber') {
    //       params.school_id = 92;
    //     }
    //     let res = await this.$api.account.mobRegister(params);
    //     if (res.code === 0) {
    //       this.$message({
    //         message: '请补充相关信息',
    //         type: 'success',
    //         center: true,
    //       });
    //       let school_id = this.$route.params.school_id;
    //       let id = this.$route.params.id;

    //       if (this.$route.query.invite_student_id) {
    //         this.$router.push(`/share/${school_id}/${id}?register_source=${this.$route.query.register_source}&student_id=${this.$route.query.invite_student_id}`);
    //       } else {
    //         this.$router.push(`/share/${school_id}/${id}?register_source=${this.$route.query.register_source}`);
    //       }
    //     }
    //   } catch (e) {
    //     console.log('​catch -> e', e);
    //   }
    // },
    wxmini() {
      let webpageUrl = window.location.href.replace(/&system=[a-zA-Z]*/g, '');
      let url = window.location.href.replace(/&system=[a-zA-Z]*/g, '');
      let userName = 'gh_e42312e6c65f';
      let schoolId = this.$route.params.school_id;
      let inviteId = this.$route.params.id;
      let studentId = this.$route.query.invite_student_id;
      let system = this.$route.query.system;
      let path = `/pages/pageA/invite-register/invite-register?schoolId=${schoolId}&inviteId=${inviteId}&source=student&studentId=${studentId}&system=${system}`;
      let withShareTicket = true;
      let miniprogramType = 0; // 0 正式 1 开发 2 体验
      let title = this.title; // 邀请链接title
      let desc = this.info.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ''); // 邀请链接desc
      let imageurl = 'http://www.xixunyun.com/images/logo.png'; // 邀请链接图片
      let wx_title = this.title; // 小程序title
      let wx_desc = ''; // 小程序desc
      let wx_imageurl = 'http://www.xixunyun.com/images/wxmini.jpg'; // 小程序图片
      let imgUrl = 'http://www.xixunyun.com/images/wxmini.jpg';
      let obj = {
        url,
        userName,
        path,
        withShareTicket,
        miniprogramType,
        title,
        desc,
        imageurl,
        wx_title,
        wx_desc,
        wx_imageurl,
      };
      console.log(obj);

      switch (this.$route.query.system) {
        case 'ios':
          // console.log(vern);
          // if (vern != 'new') {
          //   wxMiniShare(JSON.stringify(obj));
          // } else {
          window.webkit.messageHandlers.wxMiniShare.postMessage(JSON.stringify(obj));
          // }
          // wxMiniShare(JSON.stringify(obj));
          // window.webkit.messageHandlers.wxMiniShare.postMessage(JSON.stringify(obj))

          break;
        case 'android':
          client.wxMiniShare(webpageUrl, userName, path, withShareTicket, title, desc, imgUrl);
      }
      // setTimeout(function(){
      //   this.goBack();
      // },4000)
      // this.goBack();
    },
    wxmini1() {
      let webpageUrl = window.location.href.replace(/&system=[a-zA-Z]*/g, '');
      let url = window.location.href.replace(/&system=[a-zA-Z]*/g, '');
      let userName = 'gh_e42312e6c65f';
      let schoolId = this.$route.params.school_id;
      let inviteId = this.$route.params.id;
      let studentId = this.$route.query.invite_student_id;
      let system = this.$route.query.system;
      let path = `/pages/pageA/invite-register/invite-register?schoolId=${schoolId}&inviteId=${inviteId}&source=student&studentId=${studentId}&system=${system}`;
      let withShareTicket = true;
      let miniprogramType = 2; // 0 正式 1 开发 2 体验
      let title = this.title; // 邀请链接title
      let desc = this.info.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ''); // 邀请链接desc
      let imageurl = 'http://www.xixunyun.com/images/logo.png'; // 邀请链接图片
      let wx_title = this.title; // 小程序title
      let wx_desc = ''; // 小程序desc
      let wx_imageurl = 'http://www.xixunyun.com/images/wxmini.jpg'; // 小程序图片
      let imgUrl = 'http://www.xixunyun.com/images/wxmini.jpg';
      let obj = {
        url,
        userName,
        path,
        withShareTicket,
        miniprogramType,
        title,
        desc,
        imageurl,
        wx_title,
        wx_desc,
        wx_imageurl,
      };
      console.log(obj, 'aaa');
      switch (this.$route.query.system) {
        case 'ios':
          console.log(111)
          // wxMiniShare(JSON.stringify(obj));
          window.webkit.messageHandlers.wxMiniShare.postMessage(JSON.stringify(obj))

          break;
        case 'android':
          console.log(222)

          client.wxMiniShare(webpageUrl, userName, path, withShareTicket, title, desc, imgUrl);
      }
    },
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase();
      console.log(ua);

      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        console.log('是微信');

        return true;
      } else {
        console.log('不是微信');

        return false;
      }
    },
  },
};
</script>

<style lang="scss">
p {
  color: #505050;
}
</style>
<style scoped lang="scss">
@import '../../assets/css/base.scss';

#main {
  margin: 0;
  padding: 0;
  font-size: 14px;
  width: 100vw;
  height: 100%;
  min-height: 600px;
  color: #505050;
  background: url('../../assets/img/bg.png') no-repeat;
  background-size: 100%;

  .detail {
    color: #fff;
    padding: vw(40) vw(42) vw(35);
    text-align: center;
    font-size: vw(40);
  }

  .con {
    width: vw(652);
    background: #fff;
    box-shadow: 0px 20px 45px 0px rgba(38, 118, 194, 0.18);
    font-size: vw(21);
    border-radius: vw(23);
    margin: 0 auto;
    padding: vw(28) vw(42);
    box-sizing: border-box;
    line-height: 1.5;
    font-size: vw(30);
  }

  .container {
    // width: 80%;
    border-width: 0;
    border-color: rgb(108, 152, 188);
    margin: 0 auto;
    margin-bottom: 30px;

    .form {
      margin-top: 20px;
      padding: 0 10px 10px 10px;

      .el-form-item {
        margin-left: auto;
        margin-right: auto;
      }

      .el-form-item__content {
        margin-left: 0;
        width: 50%;
      }

      .el-button {
        // font-size: 12px;
        padding: 12px;
      }

      .code {
        position: relative;

        .btn {
          position: absolute;
          right: 0;
        }
      }

      .next {
        width: 100%;
        height: vw(67);
        text-align: center;
        line-height: vw(67);
        border-radius: vw(33);
        background: #66aef4;
        color: #fff;
        font-size: vw(28);
        border: none;
        outline: none;
      }
    }
  }
}

.pop,
.pop1 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);

  img {
    width: 100vw;
  }
}

.pop1 {
  padding: 15px;

  .img-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
    }
  }

  .line-wrap {
    position: relative;

    img {
      position: absolute;
      right: 24px;
      top: 0;
      width: 37px;
      height: 37px;
    }

    div {
      position: absolute;
      right: 0;
      top: 37px;
      z-index: 1;
      width: 200px;
      background: #fff;
      border-radius: 10px;
      color: #6d6d6d;
      padding: 10px;

      span {
        color: #1990ee;
      }
    }
  }

  .no-share {
    color: #fff;
    margin-top: 300px;
    text-align: center;
  }
}

/* 邀请企业样式 */
.dialog1 {
  // display   : none;
  z-index: 1;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.invite-wrap {
  width: 80vw;
  margin: 100px auto 0;
  padding: 20px 0;
  color: #000;
  border-radius: 10px;
  background: #fff;
  text-align: center;
}

.invite {
  padding: 0 10px;
}

.invite p {
  color: #000;
  font-size: 16px;
}

.invite-btn {
  margin-top: 10px;
  background: #fff;
}

.copy {
  width: 80%;
  height: 100px;
}

.inv .desc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #6d6d6d;
  font-size: 14px;
}

.yq {
  position: relative;
  z-index: 1;
}

.inv .desc .con {
  position: absolute;
  right: 17px;
  top: 40px;
  display: block;
  text-align: right;
}

.inv .desc .con span {
  display: block;
  background: #fff;
  border-radius: 30px;
  text-align: center;
  width: 300px;
  padding: 15px;
}

.inv .desc img {
  width: 37px;
  height: 37px;
  margin-right: 60px;
}

@media screen and (min-width: 500px) {
  #main {
    background-size: 100% 500px;

    .detail {
      font-size: 30px;
    }

    .con {
      width: 500px;
      font-size: 18px;
    }

    .container {
      width: 500px;

      .form {
        .next {
          height: 50px;
          line-height: 50px;
          font-size: 18px;
        }
      }
    }
  }
}

.hiddden {
  height: 100vh !important;
  overflow: hidden;
}

.we {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.7);

  img {
    width: 100vw;
    height: 90px;
  }
}
</style>